<template>  
  <div :id="'psa-card-'+photo.id" class='psa-card' v-if="!photoIsDenied" :data-attendee-id='eventAttendee.id'>

    <div class='psa-card__top'>
      <div class='psa-card__overlay' v-if="this.canManage">
        <div v-if='fetchingApproveStatus'>
          <i class='fa fa-spinner fa-spin fa-2x text-white'></i>
        </div>
        <div class="post-btn">
          <div aria-label="Click to approve post" class='approve-post-btn mr-3' v-if="!photo.approved && !fetchingApproveStatus" @click="approvePhoto()">
          Approve Post
        </div>
        <div aria-label="Click to remove post" class='delete-post-btn' ref='showModalBtn' @click="openModal()" v-if="!fetchingApproveStatus">
          <i class="far fa-eye-slash"></i>
        </div>
        </div>
        <photo-stream-modal 
          v-if='showModal'
          v-on:close="closeModal"
        >
          <template #header>
            <div class='title hide-post-title'>
              Hide Post
            </div>
          </template>
          <template #body>
            <div class="hide-post-modal-container row">
              <div id="hide-post-modal-text" class="hide-post-modal__text col-sm-12">Are you sure you want to permanently hide this Post?</div>
            </div>
            <br>
            <div class="hide-post-btn-container">
              <button aria-label="Cancel Button" type="button" class="btn modal-close btn-danger mr-2 cancel-hide-post-btn" v-on:click="closeModal">Cancel</button>
              <button aria-label="Button to hide post" type="button" class="btn modal-close btn-success hide-post-btn mr-2" v-on:click="denyPhoto">Hide</button>
            </div>
          </template>

        </photo-stream-modal>
      </div>

      <div class='psa-card__header'>
        <div class='psa-card__pending-approval-banner' v-if="this.requiresApproval && !this.photo.approved">
          pending approval
        </div>
        <div class='psa-card__header-content'>
          <div v-if="userAvatarUrl">
            <img class='psa-card__user-avatar' :src="userAvatarUrl" alt="User Avatar">
          </div>
          <div class='psa-card__user-avatar' v-if="!userAvatarUrl">
            {{initials}}
          </div>
          <div class='psa-card__posters-info'>
            <div class='psa-card__posters-name'>{{ attendeeName }}</div>
            <div class='psa-card__posters-subheader-info' v-html="subheaders">
            </div>
            <div class='psa-card__post-time'>{{ createdFromNow() }}</div>
          </div>
        </div>
      </div>

      <div class='psa-card__post-content' v-if='hasContent'>
        <img ref='img' :src="photo.photo_url_default" class='psa-card__image' v-if="isImage" alt="Photo Stream Photo" download style="-webkit-touch-callout: default;"/>
        <!-- <img ref='img' :src="photo.photo_url.replace(/^https:\/\//i, 'http://')" class='psa-card__image' v-if="isImage" /> -->
        <video v-if="isVideo" height="auto" width="100%" controls="controls" class='psa-card__video' aria-label="Video post">
          <!-- <source :src="photo.photo_url.replace(/^https:\/\//i, 'http://')"> -->
          <source :src="photo.photo_url">
        </video>
      </div>

    </div>

    <div class='psa-card__footer'>
      <div class='photo-post' v-html="this.urlifyCaption">
      </div>

      <div class='psa-card__user-tags' v-if="photo.tagged_attendee_names && photo.tagged_attendee_names.length">
        <span class='psa-card__tag' v-for="(taggedAttendee, i) in photo.tagged_attendee_names" :key="i">
          {{`${taggedAttendee.first_name} ${taggedAttendee.last_name}`}}
        </span>
      </div>

      <div class='psa-card__comment-like-row'>

        <div class="'psa-card__share'" v-if="canShare" @click="sharePhotoStreamPhoto()">
          <i class="fal fa-2x fa-share-alt"></i>
        </div>
        
        <div class='psa-card__comment-count' @click="toggleComments()">
          <span v-if="this.hasComments" class="psa-card__comment-count-text"  aria-label="Click to see comments">
            {{ (photo.comments.length> 1)? lang.get('event_strings.photo_stream.comment_plural_js').replace("{AMOUNT}",photo.comments.length):lang.get('event_strings.photo_stream.comment_single_js').replace("{AMOUNT}",photo.comments.length) }}
          </span>
        </div>

        <div aria-label="Click to like" class='psa-card__likes' @click='toggleLike()'>
          <span v-if="this.hasLikes" class='psa-card__likes-count'>
            {{ (photo.likes.length > 1)? lang.get('event_strings.photo_stream.like_plural_js').replace("{AMOUNT}",photo.likes.length):lang.get('event_strings.photo_stream.likes_single_js').replace("{AMOUNT}",photo.likes.length) }}
          </span>
          <i v-show="this.iLiked" class="fas fa-2x fa-heart"></i>
          <i v-show="!this.iLiked" class="fal fa-2x fa-heart"></i>
        </div>
      </div> 

      <div class='psa-card__comments' v-if="shouldShowComments">
        <photo-stream-comment
          v-for='comment in photoComments'
          :key="comment.id"
          v-bind:comment="comment"
          v-bind:photo="photo"
          v-bind:eventAttendee="eventAttendee"
          @edit-comment="handleEditComment"
          @delete-comment="handleDeleteComment"
        >
        </photo-stream-comment>
      </div>

    </div>

    <div class='psa-card__comment-form'>
      <input aria-label="Comment text Field" type='text' class='psa-card__comment-input' ref='comment' :placeholder=" lang.get('event_strings.photo_stream.add_comment')">
      <div 
        tabindex="0" 
        class='psa-card__submit' 
        v-on:keyup.enter="handleSubmitComment"
        @click="handleSubmitComment()"
      >
        {{ lang.get('event_strings.photo_stream.post_text') }}
      </div>
    </div>

    <div class='psa-card__actions' v-if="myPost">
      <a 
        class="btn btn-sm action-btn" 
        data-toggle="tooltip" 
        data-placement="top" 
        title="Edit Post" 
        @click="editPost(photo)"
      >
        <i class="far fa-edit"></i>
      </a>

      <a class="btn btn-sm action-btn" data-toggle="tooltip" data-placement="top" title="Delete Post" @click="openModal('delete')">
          <i class="far fa-trash text-danger"></i>
      </a>

      <!-- Delete Modal -->
      <photo-stream-modal 
          class="psa__delete-post-modal"
          v-if='showDeleteModal'
          v-on:close="closeModal('delete')"
        >
          <template #header>
            <div class='title'>
              Delete Post
            </div>
          </template>
          <template #body>
            <div class="delete-post-modal-container">
              <div class="delete-post-modal__text">Are you sure you want to permanently delete this Post?</div>
            </div>
            <br>
            <div>
              <button aria-label="Cancel Button" type="button" class="btn modal-close btn-danger mr-2" v-on:click="closeModal('delete')">Cancel</button>
              <button aria-label="Button to delete post" type="button" class="btn modal-close btn-success mr-2" v-on:click="deletePost">Delete</button>
            </div>
          </template>
        </photo-stream-modal>
        <!-- End Delete Modal -->
    </div>

  </div>
</template>

<script>
import axios from 'axios';
export default {
  // name: "attendees-modal",
  props: ["eventId", 'streamId', 'manage', 'apiAuthToken', 'photo', 'eventAttendee', 'canManage', 'requiresApproval', 'baseUrl', 'isWeb', 'subheaderOne', 'subheaderTwo'],

  data () {
    return {
      commentsVisible: false,
      fetchingApproveStatus: false,
      showModal: false,
      showDeleteModal: false,
    }
  },

  computed: {

    shareData () {
      if (!this.photo.photo_url) return false
      return {
        url: this.photo.shareable_photo_url,
      }
    },

    publicStorageType () {
      return (this.photo.storage_type == 'public')
    },

    canShare () {
      if (!this.shareData) return false
      if (!this.publicStorageType) return false
      if (!navigator.share) return false
      return true
    },

    photoComments () {
      var nestedReplies = this.groupCommentsByParentId()

      var comments = this.photo.comments.map((c,i) => {
        c.replies = (nestedReplies[c.id]) ? nestedReplies[c.id] : []
        return c
      }).filter((c,i) => !c.parent_id)

      return comments
    },

    urlifyCaption () {

      function removeTags(str) {
          if ((str===null) || (str===''))
          return false;
          else
          str = str.toString();
          return str.replace( /(<([^>]+)>)/ig, '');
      }

      var caption = removeTags(this.photo.photo_caption)
      if (!caption) caption = ''

      if (caption) {
        var hashtagReplacePattern = /(\s#[a-z0-9][a-z0-9\-_]*)/ig;
        caption = caption.replace(hashtagReplacePattern, '<a class="hash-tag" data-hash-tag="$1" target="_blank">$1</a>');
      }
      
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      return caption.replace(urlRegex, function(url) {
        return '<a target=_blank href="' + url + '">' + url + '</a>';
      })

    },

    myPost () {
      return this.photo.event_attendee_id === this.eventAttendee.id
    },

    myLike () {
      if (!this.photo.likes || !this.photo.likes.length) return false
      return this.photo.likes.find((like) => like.event_attendee_id === this.eventAttendee.id)
    },

    iLiked () {
      return !!this.myLike
    },

    hasLikes () {
      return this.photo.likes && this.photo.likes.length > 0
    },

    hasComments () {
      return this.photo.comments && this.photo.comments.length > 0
    },

    attendeeName () {
      return this.photo.attendee_name
    },

    hasContent () {
      return this.photo.photo_url
    },

    isImage () {
      return this.photo.photo_content_type
        && this.photo.photo_content_type.includes('image')
    },

    isVideo () {
      return this.photo.photo_content_type
        && this.photo.photo_content_type.includes('video')
    },

    initials () {
      var attendeeFields = this.photo.event_attendee && this.photo.event_attendee.attendee_fields 
      if (!attendeeFields) return
      if (attendeeFields.first_name && attendeeFields.last_name) {
        return `${attendeeFields.first_name[0]} ${attendeeFields.last_name[0]}`
      }
    },

    userAvatarUrl () {
      var attendeeFields = this.photo.event_attendee && this.photo.event_attendee.attendee_fields 
      if (!attendeeFields) return
      if (attendeeFields.user_avatar_url) {
        return `${attendeeFields.user_avatar_url}`
      }
    },

    momentCreatedAt () {
      return new moment.utc(this.photo.created_at)
    },

    subheaders () {
      var attendeeFields = this.photo.event_attendee && this.photo.event_attendee.attendee_fields 
      var subOne = this.subheaderOne;
      var subTwo = this.subheaderTwo;
      var temp = '';
      if (!attendeeFields) return
      if (attendeeFields[subOne] != null) {
        temp += "<span class='" + subOne + "'>" + attendeeFields[subOne] + "</span>";
        if (attendeeFields[subTwo] != null) temp += "<span>, </span>";
      }
      if (attendeeFields[subTwo] != null) {
        temp += "<span class='" + subTwo + "'>" + attendeeFields[subTwo] + "</span>";
      }
      return temp;
    },
    
    shouldShowComments () {
      return this.commentsVisible && this.photo.comments.length
    },

    photoIsDenied () {
      return this.photo.hidden && this.requiresApproval
    }

  },

  methods: {

    editPost (post) {
      this.$emit('edit-photo', post)
    },

    deletePost () {
      var self = this
      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/photos/${this.photo.id}`);

      axios.delete(url, {
        api_auth_token: this.apiAuthToken
      }).then((res) => {
        self.closeModal('delete')
        if (res.data && res.data.data) {
          self.$emit('delete-photo', res.data.data)
        }
      }).catch((err) => {
        console.log(err)
      })
    },

    handleEditComment(comment, editedText) {
      this.$emit('edit-comment', comment, editedText);
    },

    handleDeleteComment(comment) {
      var self = this
      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/photos/${this.photo.id}/comments/${comment.id}`);

      axios.delete(url, {
        api_auth_token: this.apiAuthToken
      }).then((res) => {
        self.closeModal()
      }).catch((err) => {
        console.log(err)
      })
    },

    groupCommentsByParentId () {
      var comments = this.photo.comments.reduce(function(c, x) {
        (c[x['parent_id']] = c[x['parent_id']] || []).push(x);
        return c;
      }, {});

      return comments
    },

    closeModal (modalType) {
      if (modalType === 'delete') {
        this.showDeleteModal = false
      } else {
        this.showModal = false
      }
    },

    openModal (modalType) {
      if (modalType === 'delete') {
        this.showDeleteModal = true
      } else {
        this.showModal = true
      }
    },

    toggleLike () {
      this.iLiked 
        ? this.$emit('unlike', this.photo, this.myLike) 
        : this.$emit('like', this.photo)
    },

    emitApprovedPhoto () {
      this.$emit('approved-photo', this.photo)
    },
    
    emitDeniedPhoto () {
      this.$emit('deny-photo', this.photo)
    },

    sharePhotoStreamPhoto () {
      if (!navigator.share) {
        alert('Sorry, your browser does not support sharing')
        return
      }

      navigator.share(this.shareData)
        .then(() => console.log('Thanks for sharing!'))
        .catch(console.error);
    },    

    approvePhoto () {
      this.fetchingApproveStatus = true

      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/photos/${this.photo.id}/approve`);

      axios.post(url, {
        api_auth_token: this.apiAuthToken
      }).then((res) => {
        if (res.data && res.data.data) {
          this.$emit('approved-photo', res.data.data)
        } else {
          throw error('no approval returned')
        }
      }).catch((err) => {
        Vue.toasted.show('error approving post', {
          type: 'error', 
          duration: 4000,
          position: 'bottom-right',
          action: {
            text: 'DISMISS',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }            
          }}
        );
      }).finally(() => {
        this.fetchingApproveStatus = false
      })
    },

    denyPhoto () {
      self = this
      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/photos/${this.photo.id}/approve/1`);
      axios.post(url, {
        _method: "delete",
        api_auth_token: this.apiAuthToken
      }).then((res) => {
        self.closeModal()
        if (res.data && res.data.data) {
          self.$emit('denied-photo', res.data.data)
        } else {
          throw error('no data returned')
        }
      }).catch((err) => {
        Vue.toasted.show('error un-approving post', {
          type: 'error', 
          duration: 4000,
          position: 'bottom-right',
          action: {
            text: 'DISMISS',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }            
          }}
        );
      })
    },    

    handleSubmitComment (data) {
      const commentText = data ? data.replyText : this.$refs.comment.value
      const parentId = data ? data.parentId : null;

      if (commentText.length === 0) {
        return
      }

      this.$emit('comment', this.photo, commentText, parentId)

      if (this.$refs.comment) {
        this.$refs.comment.value = ''
      }
      this.commentsVisible = true
    },

    likeComment (photo, comment, like) {
      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/photos/${photo.id}/comments/${comment.id}/likes`); 

      axios({
        method: 'POST',
        url: url,
        data: { api_auth_token: this.apiAuthToken},
        responseType: 'json'
      }).then((res) => {
        if (res.data && res.data.like) {
          // should probably clean up endpoint, gives 200 even when does not create when one already exists,
          // dont know what else uses atm though
          const newLike = res.data.like
          if (comment.likes.find(like => like.id === newLike.id)) return
          var newComment = this.photo.comments.find((c) => c.id === comment.id)
          newComment.likes.push(newLike)
        }
      }).catch((err) => { console.log(err) })
    },

    unLikeComment (photo, comment, like) {
      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/photos/${photo.id}/comments/${comment.id}/likes/${like.id}`); 

      axios({
        method: 'DELETE',
        url: url,
        data: { api_auth_token: this.apiAuthToken},
        responseType: 'json'
      }).then((res) => {
        var newComment = this.photo.comments.find((c) => c.id === comment.id)
        newComment.likes = comment.likes.filter((l) => l.id !== like.id)
        this.photo.comments.forEach((c) => {
          if (c.id === newComment) c = newComment
        })
      }).catch((err) => {
        console.log(err)
      })
    },

    createdFromNow() {
      // Calculate the diff in seconds from the current time
      const momentDate = this.momentCreatedAt;
      const seconds = Math.floor((new Date() - momentDate) / 1000);

      // Check for recent timestamp
      if (seconds < 5) {
        return this.lang.get('event_strings.time_frames.just_now');
      }

      // Define time intervals
      const intervals = {
        year: 31536000,
        month: 2592000,
        day: 86400,
        hour: 3600,
        minute: 60
      };

      // Set the appropriate time frame
      const getTimeFrame = (seconds, intervals) => {
        for (const [key, value] of Object.entries(intervals)) {
          const interval = Math.floor(seconds / value);
          if (interval >= 1) {
            return this.lang.get(`event_strings.time_frames.${key}s_ago_js`).replace('{AMOUNT}', interval);
          }
        }
        // Default to seconds if no other conditions met
        return this.lang.get('event_strings.time_frames.seconds_ago_js').replace('{AMOUNT}', seconds);
      };

      // Return localized message
      return getTimeFrame(seconds, intervals);
    },

    toggleComments () {
      return this.commentsVisible = !this.commentsVisible
    },

    updatePhotoCardForTImeSince () {
      window.setTimeout(() => {
        this.$forceUpdate()
        this.updatePhotoCardForTImeSince()
      }, 10000)
    },

    getFormattedURL(relativePath) {
      var url = relativePath

      if(this.isWeb != 'true') {
        url = `/events/${this.eventId}`+url
      }

      if ((typeof this.baseUrl === 'string' || this.baseUrl instanceof String) && this.baseUrl != '') {
        url = this.baseUrl+url
      }

      return url
    },  
  },

  mounted: function () {
    EventBus.$on('likeComment', this.likeComment)
    EventBus.$on('unlikeComment', this.unLikeComment)
    EventBus.$on(`submitComment-${this.photo.id}`, this.handleSubmitComment)

    this.updatePhotoCardForTImeSince()
    if (!this.$refs.img) return
    this.$refs.img.onerror = function () {
      this.onerror = ''
      this.src = "/assets/placeholder_broken_image.png";  
    }
  }
};

</script>

<style scoped>
  .psa-card {
    position: relative;
    width: 100%;
    margin-bottom: 2rem;
    border: 1px solid rgba(156,156,156,0.75);
    border-radius: .25rem;
    background-color: var(--theme-content-bg-color);
    color: var(--theme-content-bg-text-color);
  }

  .psa-card__top {
    position: relative;
  }

  .psa-card__top .psa-card__overlay {
    transition: ease-out 0.2s;
  }

  .psa-card:hover .psa-card__top .psa-card__overlay {
    bottom: 0;
    height: 100%;
    transition: ease-in-out 0.2s;
  }

  .psa-card__overlay {
    position: absolute;
    bottom: 100%;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    overflow: hidden;
    width: 100%;
    height: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .psa-card__overlay > * {
    margin: 2rem;
  }

  .approve-post-btn {
    padding: 0.6rem 2rem;
    border-radius: 80px;
    border: 2px solid #ffffff;
    color: #ffffff;
    background-color: rgba(0,0,0,0%);
    cursor: pointer;
    z-index: 100;
  }

  .delete-post-btn {
    padding: 2rem;
    border-radius: 100%;
    border: 2px solid #ffffff;
    color: #ffffff;
    background-color: rgba(0,0,0,0%);
    cursor: pointer;
    z-index: 100;
  }

  .delete-post-btn:hover, .approve-post-btn:hover {
    background-color: rgba(0,0,0,20%);
  }

  .psa-card__header {
    display: flex;
    flex-direction: column;
  }

  .psa-card__pending-approval-banner {
    display: flex;
    justify-content: center;
    background-color: red;
    color: #fff
  }

  .psa-card__header-content {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .psa-card__user-avatar {
    width: 4em;
    height: 4em;
    margin: 10px;
  }

  .psa-card__image {
    width: 100%;
    object-fit: contain;
  }

  .psa-card__footer {
    padding: 1rem;
  }

  .photo-post {
    white-space: pre-line;
  }

  .psa-card__posters-info {
    display: flex;
    flex-direction: column;
  }

  .psa-card__posters-info * {
    color: var(--theme-content-bg-text-color);
  }

  .psa-card__comment-like-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-weight: bold;
    margin-top: 1.2rem;
    margin-bottom: 1.2rem;
  }

  
  .psa-card__user-tags {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    font-size: 1.3rem;
    font-weight: bold;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }  

  .psa-card__user-tags > * {
    margin-right: 0.4rem
  }
  .psa-card__tag {
    font-size: 14px;
    background-color: var(--theme-primary-color);
    color: #FFFFFF;
    padding: 0 5px;
    border-radius: .25em;
    margin-bottom: 0.4rem;
  }

  .psa-card__comment-form {
    display: flex;
    border-top: 0.2px solid rgba(232, 236, 241, 60%);
  }

.psa-card__comment-input {
  flex: 1;
  padding: 1.5rem;
  padding-left: 1rem;
  border: none;
  background-color: var(--theme-content-bg-color);
  border-bottom-left-radius: .25em;
}

.psa-card__submit {
  padding: 1.5rem;
  padding-right: 1rem;
  color: var(--theme-primary-color);
  font-weight: 600;
  cursor: pointer;
}

.psa-card__likes {
  display: flex;
  justify-content: center;
  align-items: center;    
}

.psa-card__likes-count {
  font-weight: bold;
  padding-right: 0.4rem;
}

.psa-card__likes .fa-heart,
.fa-share-alt {
  color: var(--theme-primary-color);
  cursor: pointer;
}

.psa-card__comment-count {
  display: flex;
  align-items: center;
}

.psa-card__comment-count-text {
    color: var(--theme-primary-color);
    font-weight: normal;
    cursor: pointer;
  }

.psa-card__video {
  max-height: 70vh;
}

.post-btn {
  display: flex;
  align-items: center;
}

.psa-card__actions {
  padding: 1em;
  text-align: right;
}
.psa-card__actions .fa-edit {
  color: black;
}
.psa-card__actions .btn.action-btn {
    background: transparent;
    border: none;
    font-size: 15px;
    box-shadow: none !important;
}
.delete-post-modal-container {
  text-align: center;
}

.baseEvent .hide-post-btn-container {
  display: flex;
  justify-content: center;
  padding: 0 0 10 0;
  gap: 15px;
}

.baseEvent .psa-modal {
  max-height: 150px;
}

.baseEvent #hide-post-modal-text {
  display: flex;
  justify-content: center;
  font-size: 15px;
  padding: 10 !important;
}

.baseEvent #photo-stream-app-content .modal-header {
  padding: 15px;
  height: 40px;
}

.baseEvent .psa-modal__close-btn {
  width: 2rem;
  height: 2rem;
}

.baseEvent .psa-modal-mask {
  margin: 0px;
}

.baseEvent .delete-post-btn {
  padding: 1rem;
}

.baseEvent .hide-post-title {
  display: block !important;
  font-size: 22px;
}

.baseEvent .cancel-hide-post-btn,
.baseEvent .hide-post-btn {
  display: inline-block;
  border-radius: 20px !important;
  font-size: var(--base-default-font-size);
  padding: 0px 15px;
  background-color: var(--theme-secondary-text-color) !important;
  color: var(--theme-secondary-color) !important;
  margin: 0 !important
}

.baseEvent .hide-post-btn {
  color: var(--theme-secondary-text-color) !important;
  background-color: var(--theme-secondary-color) !important;
}
</style>


